var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgNwonLogoDark = function SvgNwonLogoDark(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 589.071 155.233",
    xmlSpace: "preserve",
    preserveAspectRatio: "xMinYMid",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1a171b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.065.125v151.582H31.11V72.445l84.556 82.913v-42.59zM85.207.125v42.592L200.81 155.358V72.97l84.554 82.388V3.776h-31.046V83.04L169.76.125v42.592l.003.003v40.32zM473.534.125v151.582h31.046V72.445l84.556 82.913v-42.59zM558.674 42.717l30.462 29.68V29.992L558.674.125zM379.45 1.95c-41.821 0-75.792 33.788-75.792 75.791 0 41.822 33.786 75.79 75.792 75.79 41.82 0 75.789-33.785 75.789-75.79 0-41.822-33.786-75.79-75.79-75.79zm0 120.535a44.584 44.584 0 0 1-44.745-44.744 44.584 44.584 0 0 1 44.745-44.744 44.581 44.581 0 0 1 44.74 44.744 44.581 44.581 0 0 1-44.74 44.744z"
  }))));
};

export default SvgNwonLogoDark;